// styles.ts
import styled from 'styled-components';

export const RadioTable = styled.table`
  width: 100%;
  margin-bottom: 1rem;

  tr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;

    td {
      display: flex;
      align-items: center;

      input[type='radio'] {
        margin-right: 0.5rem;
      }

      .pricing {
        font-weight: bold;
        color: ${props => props.theme.colors.tertiary};
      }
    }
  }
`;
